import { Redirect } from "react-router-dom";
import React, { useEffect, useState } from "react";
import Api from "./baseApi";
import { useTunnelData } from "./TunnelContext";
import LoadingScreen from "./components/LoadingScreen";
import { useConfig } from "./ConfigProvider";
import { useTranslation } from "react-i18next";

const PRODUCTS_TTL = 1000 * 60 * 5;

function extract_price(txt, currency) {
  let capture = null;
  if (currency === "€") {
    capture = /([0-9]+)(,([0-9]+))?€([^,]*),(.*)/.exec(txt);
    if (capture) {
      return {
        full: txt,
        price_1: capture[1],
        price_2: capture[2],
        price_3: capture[3],
        price_4: capture[4],
      };
    }
    capture = /([0-9]+)(,([0-9]+))?€(.*)/.exec(txt);
    if (capture) {
      return {
        full: txt,
        price_1: capture[1],
        price_2: capture[3],
        price_3: capture[4],
        price_4: null,
      };
    }
  } else if (currency === "DHS") {
    capture = /^([0-9]+ ?[0-9]*)DHS?$/.exec(txt);
    if (capture) {
      return {
        full: txt,
        price_1: capture[1].replace(/ /g, ""),
        price_2: "",
        price_3: "",
        price_4: "",
      };
    }
    capture = /^([0-9]+ ?[0-9]*)DHS?(.*)$/.exec(txt);
    if (capture) {
      return {
        full: txt,
        price_1: capture[1].replace(/ /g, ""),
        price_2: "",
        price_3: capture[2],
        price_4: "",
      };
    }
  } else {
    console.warn("Cannot process with currency", currency);
  }

  console.warn("Cannot extract prices from", txt);
  return {
    full: txt,
    price_1: "??",
    price_2: "00",
    price_3: "durée",
    price_4: "price_4",
  };
}

export default function ProductsLoader({ children, allowNoUser }) {
  const [step, setStep] = useState("PRODUCTS_LOAD");
  const { tunnel, setTunnel } = useTunnelData();
  const { currency, code } = useConfig();
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!tunnel.club) return;
    setStep("PRODUCTS_LOAD");

    if (tunnel.products && Date.now() < tunnel.products.date + PRODUCTS_TTL) {
      setStep("OK");
      return;
    }
    const [query] = Api.GET({
      path: "/api/abo/resamania2/products",
      query: {
        msdsId: tunnel.club.msdsId,
        tunnelUid: tunnel.uid,
        full: true,
      },
    });
    query
      .then((ret) => {
        return ret
          .filter((r) => {
            if (!r.description) {
              console.warn("Skip product", r, "no description");
              return null;
            }
            return r;
          })
          .map((r) => {
            r.data.d = r.description;
            r.data.d.features = [
              r.data.d.feature_0,
              r.data.d.feature_1,
              r.data.d.feature_2,
              r.data.d.feature_3,
              r.data.d.feature_4,
              r.data.d.feature_5,
            ];
            // DOC: Add top_offer in data for display de top_offer banner
            r.data.topOffer = r.top_offer;
            return r.data;
          });
      })
      .then((ret) => {
        let valid = ret.filter((p) => {
          if (p.offer.validFrom && new Date(p.offer.validFrom).getTime() > Date.now()) {
            return false;
          }
          if (p.offer.validThrough && new Date(p.offer.validThrough).getTime() < Date.now()) {
            return false;
          }

          return true;
        });
        valid = valid.filter((p) => p.highlighted).concat(valid.filter((p) => !p.highlighted));
        const plans = valid.filter((p) => p.type === "subscription" || p.type === "counter");

        plans.forEach((p) => {
          p.d = p.d || {};
          if (!p.bundleDetail?.bundledOffers) {
            return;
          }
        });
        plans.sort((a, b) => a.d.order - b.d.order);
        const options = valid.filter((p) => p.type === "subscription_option");
        options.forEach((o) => {
          const mandatoryFor = ret
            .map((p) => {
              if (p.type !== "subscription" && p.type !== "counter") return false;
              const isAMandatoryOption = p.productBehaviors.some((pb) => {
                if (!pb?.configuration?.linkedOptions) return false;
                return pb.configuration.linkedOptions.indexOf(o.offer.product) !== -1;
              });

              if (isAMandatoryOption) return p["@id"];
              return false;
            })
            .flat()
            .filter((e) => e);
          o.mandatoryFor = mandatoryFor;
        });

        const regulars = valid.filter((p) => p.type === "regular");
        setTunnel({
          ...tunnel,
          products: {
            date: Date.now(),
            clubMsdsId: tunnel.club.msdsId,
            plans,
            options,
            regulars,
          },
        });
        setStep("OK");
      })
      .catch((err) => {
        setStep("PRODUCTS_LOAD_ERROR");
        console.error(err);
      });
  }, [tunnel.club?.msdsId, tunnel.uid]);

  if (!tunnel.club) return <Redirect push to={"/"} />;

  if (step === "PRODUCTS_LOAD") {
    return <LoadingScreen LoadingText={t("loading_screen.loading_offers")} />;
  }

  if (step === "PRODUCTS_LOAD_ERROR") {
    return <p>Une erreur est survenue</p>;
  }

  return children;
}
